import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signup } from '../../api/auth';

const SignupForm = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const gender = location.state?.gender || 'male';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await signup(email, gender);
      setMessage('登録が完了しました。メールをご確認ください。');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage(error.response?.data?.message || 'エラーが発生しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>{gender === 'male' ? '男性' : '女性'}登録</h2>
      <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
        <div style={{ marginBottom: '18px' }}>
          <label style={{ display: 'block', marginBottom: '10px' }}>
            メールアドレス:
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '90%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #ccc',
              borderRadius: '5px'
            }}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: '#ff6b35',
            width:'70%',
            color: 'white',
            border: 'none',
            padding: '12px 30px',
            fontSize: '16px',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? '送信中...' : '登録'}
        </button>
      </form>
      {message && (
        <p style={{ marginTop: '15px', color: message.includes('完了') ? 'green' : 'red' }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default SignupForm; 